import axios from "axios"

const queryFiltersFormatCuentasContables = (
  endpoint: $TSMigrationFixMe,
  queryState: $TSMigrationFixMe
) => {
  if (!Object.keys(queryState).length) return `${endpoint}`
  return `${endpoint ? `${endpoint}` : ""}${
    !endpoint.includes("?") ? "?" : "&"
  }${
    queryState.FechaFinMovimiento
      ? `&FechaFinMovimiento=${queryState.FechaFinMovimiento}`
      : ""
  }${
    queryState.FechaInicioMovimiento
      ? `&FechaInicioMovimiento=${queryState.FechaInicioMovimiento}`
      : ""
  }${
    queryState.TieneMovimientos
      ? `&TieneMovimientos=true`
      : "&TieneMovimientos=false"
  }${
    queryState.CuentaContableGrupo !== null &&
    queryState.CuentaContableGrupo !== undefined
      ? `&CuentaContableGrupo=${queryState.CuentaContableGrupo.tipo}`
      : ""
  }${queryState.Descripcion ? `&Descripcion=${queryState.Descripcion}` : ""}${
    queryState.skipCount ? `&SkipCount=${queryState.skipCount}` : ""
  }${
    queryState.params ? `${queryState.params}` : ""
  }${`&MaxResultCount=${queryState.maxResult}`}`
}

export const createCuentaContableEmpresa = (
  cuentaContableEmpresaBody: $TSMigrationFixMe
) => axios.post(`/CuentaContableEmpresa`, cuentaContableEmpresaBody)

export const editCuentaContableEmpresa = (
  idCuentaEmpresa: $TSMigrationFixMe,
  cuentaContableEmpresaBody: $TSMigrationFixMe
) =>
  axios.post(
    `/CuentaContableEmpresa/${idCuentaEmpresa}`,
    cuentaContableEmpresaBody
  )

export const getGenerateExcelCuentaContable = (
  queryState: $TSMigrationFixMe
) => {
  return axios.get(
    queryFiltersFormatCuentasContables(
      "/CuentaContableEmpresa/exportar-excel",
      queryState
    ),
    {
      responseType: "blob",
    }
  )
}
